module.exports = __webpack_public_path__ + "img/Tool-frame-filled.4899c24c.svg";